import {
  AnchorHTMLAttributes,
  ExoticComponent,
  FunctionComponent,
  ReactNode,
  createContext,
  useContext,
  useMemo,
} from 'react';

//--> Interfaces and types
export type LinkComponentType = ExoticComponent<AnchorHTMLAttributes<HTMLAnchorElement>>;
interface NavigationContextValue {
  linkComponent: LinkComponentType | 'a';
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  router: any;
}
interface IProvider extends NavigationContextValue {
  children: ReactNode;
}
//--> Context
const NavigationContext = createContext<NavigationContextValue | null>(null);
//--> Provider
const NavigationContextProvider: FunctionComponent<IProvider> = ({
  children,
  linkComponent: inputLinkComponent,
  router: inputRouter,
}) => (
  <NavigationContext.Provider value={{ linkComponent: inputLinkComponent, router: inputRouter }}>
    {children}
  </NavigationContext.Provider>
);
//--> Hook
const useNavigationContext = () => {
  const context = useContext(NavigationContext);
  if (!context) throw new Error('useNavigationContext must be used within a NavigationContext');
  return useMemo(() => context, [context]);
};
export { NavigationContextProvider, useNavigationContext };
